<!-- Modal Header -->
<div class="modal-header">
  <h4 class="modal-title">Check Contact Authorization</h4>
  <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
</div>
<div class="modal-body">
  <div class="p-1">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-primary" (click)="openCustomerImagesModal(accountDetails.CustomerId)"><i class="fas fa-image"></i></button>
        <button class="btn btn-info ms-1" (click)="openAuthorizationHistoryModal(accountDetails)" #tooltip="matTooltip" matTooltip="Authorization History" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black"><i class="fas fa-history"></i></button>
      </div>
    </div>
    <table class="table table-custom">
      <tbody>
        @if (accountDetails != undefined) {
          <tr>
            <th>Customer</th>
            <td class="customerInfo" (click)="goToCustomer(accountDetails.CustomerId)">{{ authorization.CustomerName }} | {{ sharedService.processICNum(authorization.CustomerIC) }}</td>
          </tr>
          @if (contactDetails != undefined) {
            <tr>
              <th>Contact</th>
              <td>{{ contactDetails.Name }} | {{ sharedService.processICNum(contactDetails.ICNumber) }}</td>
            </tr>
          }

          <tr>
            <th>Holder Name</th>
            <td>{{ accountDetails.HolderName }}</td>
          </tr>
          <tr>
            <th>Bank Account</th>
            <td>{{ accountDetails.Bank }} | {{ accountDetails.AccountNumber }}</td>
          </tr>
        }

        <tr>
          <th>Reason</th>
          <td>{{ authorization.Remark }}</td>
        </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="col-12">
        <div>
          <p>Process Remark</p>
          <textarea class="form-control" rows="10" required [(ngModel)]="remark" name="remark"></textarea>
        </div>
      </div>

      <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="isGrant" name="isGrant"> Approve </mat-slide-toggle>

      @if (epfDetails != undefined) {
        @if (isGrant) {
          <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="untilEPFDate" name="untilEPFDate" (change)="setGrantDateToEPFDate()"> Until EPF Date </mat-slide-toggle>
        }
      }

      @if (isGrant == true) {
        <div class="col-12">
          <mat-form-field class="full-width-formField bar mt-1">
            <input matInput class="textInputLong" [matDatepicker]="myDatepicker" name="grantDueDate" [(ngModel)]="grantDueDate" placeholder="Grant Until" [disabled]="untilEPFDate" [min]="sharedService.getTodayDate()" />
            <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #myDatepicker name="date"></mat-datepicker>
          </mat-form-field>
        </div>
      }

      <div class="col-12 d-flex justify-content-end my-1">
        <button class="btn btn-success me-1" (click)="submit()" [disabled]="disabledSubmit">Submit</button>
      </div>
    </div>
  </div>
</div>

<ng-template #customerDetails let-data>
    <div class="fw-bold mb-2">
      <div>{{ data.name }} | {{ data.ic }}</div>
    </div>
</ng-template>